import type { StateAbbreviation } from '@ria-client/supergraph/marketplace/types';
import { isValidState } from '@ria-client/supergraph/utils/geo-data';
import cookies from 'js-cookie';

import { DEFAULT_STATE_OPTION, REGION_CODE_COOKIE_NAME } from './constants';

export const getSafeRegionCodeFromClientCookies = (): StateAbbreviation | undefined => {
  const regionCode = cookies.get(REGION_CODE_COOKIE_NAME) ?? '';
  return isValidState(regionCode) ? regionCode : undefined;
};

export const getSafeRegionCode = (state?: string): StateAbbreviation => {
  const regionCode = state ?? DEFAULT_STATE_OPTION;
  return isValidState(regionCode) ? regionCode : DEFAULT_STATE_OPTION;
};

export type MarketplaceEntityWithStates = { marketplaceEntity: { states?: StateAbbreviation[] } };

export const filterEntitiesByState = <T extends MarketplaceEntityWithStates>(
  items: T[],
  state?: StateAbbreviation,
): T[] => {
  if (!items) return [];
  if (!state) return items;

  return items.filter(item => {
    const validStates = item.marketplaceEntity.states;
    return !Array.isArray(validStates) || validStates.length === 0 || validStates.includes(state);
  });
};
